
import { useState, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import logo from "../../../assets/images/logo.png";
import LazyImage from "../../common/LazyImage/LazyImage";

function Navbar() {
 const [mobileOpen, setMobileOpen] = useState(false);
const [servicesOpen, setServicesOpen] = useState(false);
const [projectsOpen, setProjectsOpen] = useState(false);
const [aboutOpen, setAboutOpen] = useState(false);
const [hseqOpen, setHseqOpen] = useState(false);
const [gwsOpen, setGwsOpen] = useState(false);
const [clientsOpen, setClientsOpen] = useState(false);


  
  // const [mediaOpen, setMediaOpen] = useState(false);

  const location = useLocation();

  const navItems = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Projects", path: "/projects" },
    { label: "Careers", path: "/careers" },
    { label: "HSEQ", path: "/hseq" },
    { label: "GWS", path: "/gws" },
    { label: "Clients", path: "/clients" },
    // { label: "Awards and Recognitions", path: "/awards-and-recognitions" },
    // { label: "Industries", path: "/industries" },
    // { label: "Recruitment", path: "/recruitment" },
    // { label: "Equipment", path: "/equipment" },
    
    { label: "Contacts", path: "/contacts" },
  ];

  // const serviceItems = [
  //   { label: "All Services", path: "/services" },
  //   { label: "Drilling Services", path: "/services#drilling" },
  //   { label: "Workover & Completion", path: "/services#workover" },
  //   { label: "Operation & Maintenance", path: "/services#om" },
  //   { label: "Oilfield Equipment", path: "/services#equipment" },
  //   { label: "Manpower Supply", path: "/services#equipment" },
  // ];
  const serviceItems = [
  { label: "All Services", path: "/services" },

  {
    label: "Operations & Maintenance (O&M) Services",
    path: "/services/oam",
  },

  {
    label: "Manpower Supply",
    path: "/services/manpower",
  },

  {
    label: "Drilling Services",
    path: "/services/drilling",
  },

  {
    label: "Workover & Well Intervention Services",
    path: "/services/workover-completion",
  },

 

  // {
  //   label: "Oilfield Equipment",
  //   path: "/services/equipment",
  // },
];

  const projectItems = [
    { label: "International Projects", path: "/projects#international-operations" },
    { label: "Projects in India", path: "/projects#india-operations" },
    { label: "Awards and Recognitions", path: "/awards-and-recognitions" },
  ];

  const aboutItems = [
  { label: "Who We Are", path: "/about#who-we-are" },
  {
    label: "Vision, Mission & Core Values",
    path: "/about#vision-mission",
  },
  {
    label: "Leadership Team",
    path: "/about#leadership-team",
  },
  {
    label: "Global Reach",
    path: "/about#global-reach",
  },
  {
    label: "Major Milestones",
    path: "/major-milestone",
  },
  {
    label: "Press & Media",
    path: "/major-milestone#press-media",
  },
  {
    label: "Gallery",
    path: "/gallery",
  },
];

const servicesDropdownWidthClass = "w-72 max-w-72";
const projectsDropdownWidthClass = "w-64 max-w-64";
const aboutDropdownWidthClass = "w-72 max-w-72";
const hseqDropdownWidthClass = "w-72 max-w-72";
const gwsDropdownWidthClass = "w-72 max-w-72";
const clientsDropdownWidthClass = projectsDropdownWidthClass;

  const hseqItems = [
    { label: "Our Safety Philosophy", path: "/hseq#our-safety-philosophy" },
    { label: "HSEQ Management System", path: "/hseq#hseq-management-system" },
    { label: "HSEQ Policy", path: "/hseq#hseq-policy" },
  ];

  const gwsItems = [
    { label: "Workforce Solution", path: "/gws#integrated-workforce-solutions" },
    { label: "Industry Specific Recruitment", path: "/gws#industry-specific-recruitment" },
    { label: "Crew Management", path: "/gws#crew-management" },
    { label: "Technical Screening", path: "/gws#technical-screening" },
  ];

  const clientItems = [
    { label: "Who We Support", path: "/clients#who-we-support" },
    { label: "Global Operations", path: "/clients#global-operations" },
  ];

  const dropdownPanelClass = (widthClass) =>
    `${widthClass} overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_20px_60px_rgba(0,0,0,0.18)]`;

  const DropdownLink = ({ item }) => (
    <Link
      to={item.path}
      className="
      group
      relative
      block
      px-6
      py-4
      text-[15px]
      leading-snug
      text-slate-800
      font-medium
      whitespace-normal
      break-words
      overflow-hidden
      hover:text-red-600
      transition-all
      duration-300
      "
    >
      {item.label}

      <span
        className="
        absolute
        bottom-0
        left-0
        h-[2px]
        w-0
        bg-red-600
        transition-all
        duration-300
        group-hover:w-full
        "
      />
    </Link>
  );

  return (
    <header className="fixed top-0 left-0 right-0 z-[999] bg-[#071A2F] shadow-lg">

      <nav className="max-w-[1400px] mx-auto h-[88px] sm:h-[100px] px-4 sm:px-8 flex items-center gap-3">

        {/* Logo */}

      <Link
        to="/"
        aria-label="South Asia Consultancy — Home"
        className="flex min-w-0 flex-1 items-center gap-2.5 sm:gap-3 md:flex-initial md:shrink-0"
      >
        <LazyImage
          priority
          src={logo}
          alt="South Asia Consultancy"
          className="h-14 w-14 shrink-0 object-contain sm:h-[72px] sm:w-[72px]"
        />

        <div className="flex min-w-0 flex-col justify-center">
          <div className="text-sm font-bold leading-tight text-white sm:text-[25px] sm:leading-none sm:tracking-wide md:whitespace-nowrap">
            South Asia Consultancy
          </div>

          <p className="mt-0.5 text-[8px] uppercase leading-snug tracking-[0.08em] text-slate-300 sm:mt-1.5 sm:text-[10px] sm:leading-none sm:tracking-[0.15em] md:whitespace-nowrap">
            Operator-Driven Energy Workforce Partner
          </p>
        </div>
      </Link>
        {/* Desktop Menu */}

        <div className="hidden xl:flex items-center justify-end gap-10 ml-auto">

          {navItems.map((item, index) => (
  <Fragment key={item.label}>

    {/* ABOUT MENU */}
    {item.label === "About" ? (
      <div
        className="relative flex items-center h-full"
        onMouseEnter={() => setAboutOpen(true)}
        onMouseLeave={() => setAboutOpen(false)}
      >
        <Link
          to="/about"
          className={`group relative flex items-center gap-1 text-[15px] font-medium transition whitespace-nowrap ${
            location.pathname === "/about"
              ? "text-red-500"
              : "text-white hover:text-red-500"
          }`}
        >
          About
          <ChevronDown size={16} />

          <span
            className={`absolute -bottom-2 left-0 h-[2px] bg-red-500 transition-all duration-300 ${
              location.pathname === "/about"
                ? "w-full"
                : "w-0 group-hover:w-full"
            }`}
          />
        </Link>

        {aboutOpen && (
          <div
            className={`absolute top-full left-0 pt-3 z-[9999] ${aboutDropdownWidthClass}`}
          >
            <div className={dropdownPanelClass(aboutDropdownWidthClass)}>
              {aboutItems.map((aboutItem) => (
                <DropdownLink
                  key={aboutItem.label}
                  item={aboutItem}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    ) : item.label === "Projects" ? (

      /* PROJECT MENU */

      <div
        className="relative flex items-center h-full"
        onMouseEnter={() => setProjectsOpen(true)}
        onMouseLeave={() => setProjectsOpen(false)}
      >
        <Link
          to="/projects"
          className={`group relative flex items-center gap-1 text-[15px] font-medium transition whitespace-nowrap ${
            location.pathname === "/projects"
              ? "text-red-500"
              : "text-white hover:text-red-500"
          }`}
        >
          Projects
          <ChevronDown size={16} />

          <span
            className={`absolute -bottom-2 left-0 h-[2px] bg-red-500 transition-all duration-300 ${
              location.pathname === "/projects"
                ? "w-full"
                : "w-0 group-hover:w-full"
            }`}
          />
        </Link>

        {projectsOpen && (
          <div
            className={`absolute top-full left-0 pt-3 z-[9999] ${projectsDropdownWidthClass}`}
          >
            <div className={dropdownPanelClass(projectsDropdownWidthClass)}>
              {projectItems.map((projectItem) => (
                <DropdownLink
                  key={projectItem.label}
                  item={projectItem}
                />
              ))}
            </div>
          </div>
        )}
      </div>

    ) : item.label === "HSEQ" ? (
      <div
        className="relative flex items-center h-full"
        onMouseEnter={() => setHseqOpen(true)}
        onMouseLeave={() => setHseqOpen(false)}
      >
        <Link
          to="/hseq"
          className={`group relative flex items-center gap-1 text-[15px] font-medium transition whitespace-nowrap ${
            location.pathname === "/hseq"
              ? "text-red-500"
              : "text-white hover:text-red-500"
          }`}
        >
          HSEQ
          <ChevronDown size={16} />

          <span
            className={`absolute -bottom-2 left-0 h-[2px] bg-red-500 transition-all duration-300 ${
              location.pathname === "/hseq"
                ? "w-full"
                : "w-0 group-hover:w-full"
            }`}
          />
        </Link>

        {hseqOpen && (
          <div
            className={`absolute top-full left-0 pt-3 z-[9999] ${hseqDropdownWidthClass}`}
          >
            <div className={dropdownPanelClass(hseqDropdownWidthClass)}>
              {hseqItems.map((hseqItem) => (
                <DropdownLink key={hseqItem.label} item={hseqItem} />
              ))}
            </div>
          </div>
        )}
      </div>
    ) : item.label === "GWS" ? (
      <div
        className="relative flex items-center h-full"
        onMouseEnter={() => setGwsOpen(true)}
        onMouseLeave={() => setGwsOpen(false)}
      >
        <Link
          to="/gws"
          className={`group relative flex items-center gap-1 text-[15px] font-medium transition whitespace-nowrap ${
            location.pathname === "/gws"
              ? "text-red-500"
              : "text-white hover:text-red-500"
          }`}
        >
          GWS
          <ChevronDown size={16} />

          <span
            className={`absolute -bottom-2 left-0 h-[2px] bg-red-500 transition-all duration-300 ${
              location.pathname === "/gws"
                ? "w-full"
                : "w-0 group-hover:w-full"
            }`}
          />
        </Link>

        {gwsOpen && (
          <div
            className={`absolute top-full left-0 pt-3 z-[9999] ${gwsDropdownWidthClass}`}
          >
            <div className={dropdownPanelClass(gwsDropdownWidthClass)}>
              {gwsItems.map((gwsItem) => (
                <DropdownLink key={gwsItem.label} item={gwsItem} />
              ))}
            </div>
          </div>
        )}
      </div>
    ) : item.label === "Clients" ? (
      <div
        className="relative flex items-center h-full"
        onMouseEnter={() => setClientsOpen(true)}
        onMouseLeave={() => setClientsOpen(false)}
      >
        <Link
          to="/clients"
          className={`group relative flex items-center gap-1 text-[15px] font-medium transition whitespace-nowrap ${
            location.pathname === "/clients"
              ? "text-red-500"
              : "text-white hover:text-red-500"
          }`}
        >
          Clients
          <ChevronDown size={16} />

          <span
            className={`absolute -bottom-2 left-0 h-[2px] bg-red-500 transition-all duration-300 ${
              location.pathname === "/clients"
                ? "w-full"
                : "w-0 group-hover:w-full"
            }`}
          />
        </Link>

        {clientsOpen && (
          <div
            className={`absolute top-full left-0 pt-3 z-[9999] ${clientsDropdownWidthClass}`}
          >
            <div className={dropdownPanelClass(clientsDropdownWidthClass)}>
              {clientItems.map((clientItem) => (
                <DropdownLink key={clientItem.label} item={clientItem} />
              ))}
            </div>
          </div>
        )}
      </div>
    ) : (

      /* NORMAL MENU */

      <Link
        to={item.path}
        className={`group relative whitespace-nowrap text-[15px] font-medium transition-all duration-300 hover:text-red-500 ${
          location.pathname === item.path
            ? "text-red-500"
            : "text-white"
        }`}
      >
        {item.label}

        <span
          className={`absolute -bottom-2 left-0 h-[2px] bg-red-500 transition-all duration-300 ${
            location.pathname === item.path
              ? "w-full"
              : "w-0 group-hover:w-full"
          }`}
        />
      </Link>
    )}

    {/* SERVICES MENU */}
    {index === 1 && (
      <div
        className="relative flex items-center h-full"
        onMouseEnter={() => setServicesOpen(true)}
        onMouseLeave={() => setServicesOpen(false)}
      >
        <button
          className="group relative flex items-center gap-1 text-[15px] font-medium text-white hover:text-red-500 transition"
        >
          Services
          <ChevronDown size={16} />

          <span className="absolute -bottom-2 left-0 h-[2px] bg-red-500 transition-all duration-300 w-0 group-hover:w-full" />
        </button>

        {servicesOpen && (
          <div
            className={`absolute top-full left-0 pt-3 z-[9999] ${servicesDropdownWidthClass}`}
          >
            <div className={dropdownPanelClass(servicesDropdownWidthClass)}>
              {serviceItems.map((service) => (
                <DropdownLink
                  key={service.label}
                  item={service}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    )}
  </Fragment>
))}
          {/* Services */}

          {/* <div
            className="relative flex items-center h-full"
            onMouseEnter={() => setServicesOpen(true)}
            onMouseLeave={() => setServicesOpen(false)}
          >
            <button className="group relative flex items-center gap-1 text-[15px] text-white hover:text-red-500 transition whitespace-nowrap">

              Services

              <ChevronDown size={16} />

              <span className="absolute -bottom-2 left-0 h-[2px] bg-red-500 transition-all duration-300 w-0 group-hover:w-full" />

            </button>

            {servicesOpen && (
              <div className="absolute top-full left-0 pt-3 w-72 z-[9999]">
                <div className="bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.18)] overflow-hidden border border-slate-200">

                  {serviceItems.map((item) => (
                    <DropdownLink
                      key={item.label}
                      item={item}
                    />
                  ))}

                </div>
              </div>
            )}
          </div> */}

          {/* Media

          <div
            className="relative flex items-center h-full"
            onMouseEnter={() => setMediaOpen(true)}
            onMouseLeave={() => setMediaOpen(false)}
          >
            <button className="group relative flex items-center gap-1 text-[15px] text-white hover:text-red-500 transition whitespace-nowrap">

              Media

              <ChevronDown size={16} />

              <span className="absolute -bottom-2 left-0 h-[2px] bg-red-500 transition-all duration-300 w-0 group-hover:w-full" />

            </button>

            {mediaOpen && (
             <div className="absolute top-full left-0 pt-3 w-64 z-[9999]">
                <div className="bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.18)] overflow-hidden border border-slate-200">

                  {mediaItems.map((item) => (
                    <DropdownLink
                      key={item.label}
                      item={item}
                    />
                  ))}

                </div>
              </div>
            )}
          </div> */}

        </div>

        {/* CTA */}

        {/* <Link
          to="/contacts"
          className="
          hidden
          xl:flex
          items-center
          justify-center
          px-8
          h-12
          bg-red-600
          text-white
          rounded-full
          font-semibold
          whitespace-nowrap
          hover:bg-red-700
          hover:-translate-y-1
          transition-all
          duration-300
          "
        >
          Get A Quote
        </Link> */}

        {/* Mobile Menu Button */}

        <button
          type="button"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="ml-2 shrink-0 xl:hidden text-white"
          aria-expanded={mobileOpen}
          aria-controls="mobile-navigation"
          aria-label={mobileOpen ? "Close navigation menu" : "Open navigation menu"}
        >
          {mobileOpen ? (
            <X size={30} aria-hidden="true" />
          ) : (
            <Menu size={30} aria-hidden="true" />
          )}
        </button>

      </nav>

      {/* Mobile Menu */}

      {mobileOpen && (
        <div
          id="mobile-navigation"
          className="
          xl:hidden
          bg-[#071A2F]
          border-t
          border-white/10
          max-h-[calc(100vh-80px)]
          overflow-y-auto
          "
        >
          <div className="flex flex-col px-6 py-6">

            {navItems.map((item) => (
              <Fragment key={item.label}>
                {item.label === "About" ? (
                  <div className="py-3">
                    <Link
                      to="/about"
                      onClick={() => setMobileOpen(false)}
                      className={`block text-lg font-semibold mb-2 ${
                        location.pathname === "/about"
                          ? "text-red-500"
                          : "text-white"
                      }`}
                    >
                      About
                    </Link>
                    {aboutItems.map((aboutItem) => (
                      <Link
                        key={aboutItem.label}
                        to={aboutItem.path}
                        onClick={() => setMobileOpen(false)}
                        className="block py-2 pl-4 text-slate-300 hover:text-red-500"
                      >
                        {aboutItem.label}
                      </Link>
                    ))}
                  </div>
                ) : item.label === "Projects" ? (
                  <div className="py-3">
                    <Link
                      to="/projects"
                      onClick={() => setMobileOpen(false)}
                      className={`block text-lg font-semibold mb-2 ${
                        location.pathname === "/projects"
                          ? "text-red-500"
                          : "text-white"
                      }`}
                    >
                      Projects
                    </Link>
                    {projectItems.map((projectItem) => (
                      <Link
                        key={projectItem.label}
                        to={projectItem.path}
                        onClick={() => setMobileOpen(false)}
                        className="block py-2 pl-4 text-slate-300 hover:text-red-500"
                      >
                        {projectItem.label}
                      </Link>
                    ))}
                  </div>
                ) : item.label === "HSEQ" ? (
                  <div className="py-3">
                    <Link
                      to="/hseq"
                      onClick={() => setMobileOpen(false)}
                      className={`block text-lg font-semibold mb-2 ${
                        location.pathname === "/hseq"
                          ? "text-red-500"
                          : "text-white"
                      }`}
                    >
                      HSEQ
                    </Link>
                    {hseqItems.map((hseqItem) => (
                      <Link
                        key={hseqItem.label}
                        to={hseqItem.path}
                        onClick={() => setMobileOpen(false)}
                        className="block py-2 pl-4 text-slate-300 hover:text-red-500"
                      >
                        {hseqItem.label}
                      </Link>
                    ))}
                  </div>
                ) : item.label === "GWS" ? (
                  <div className="py-3">
                    <Link
                      to="/gws"
                      onClick={() => setMobileOpen(false)}
                      className={`block text-lg font-semibold mb-2 ${
                        location.pathname === "/gws"
                          ? "text-red-500"
                          : "text-white"
                      }`}
                    >
                      GWS
                    </Link>
                    {gwsItems.map((gwsItem) => (
                      <Link
                        key={gwsItem.label}
                        to={gwsItem.path}
                        onClick={() => setMobileOpen(false)}
                        className="block py-2 pl-4 text-slate-300 hover:text-red-500"
                      >
                        {gwsItem.label}
                      </Link>
                    ))}
                  </div>
                ) : item.label === "Clients" ? (
                  <div className="py-3">
                    <Link
                      to="/clients"
                      onClick={() => setMobileOpen(false)}
                      className={`block text-lg font-semibold mb-2 ${
                        location.pathname === "/clients"
                          ? "text-red-500"
                          : "text-white"
                      }`}
                    >
                      Clients
                    </Link>
                    {clientItems.map((clientItem) => (
                      <Link
                        key={clientItem.label}
                        to={clientItem.path}
                        onClick={() => setMobileOpen(false)}
                        className="block py-2 pl-4 text-slate-300 hover:text-red-500"
                      >
                        {clientItem.label}
                      </Link>
                    ))}
                  </div>
                ) : (
                  <Link
                    to={item.path}
                    onClick={() => setMobileOpen(false)}
                    className={`py-3 text-lg ${
                      location.pathname === item.path
                        ? "text-red-500"
                        : "text-white"
                    }`}
                  >
                    {item.label}
                  </Link>
                )}
              </Fragment>
            ))}

            {/* <div className="mt-4 pt-4 border-t border-white/10">
              <p className="text-red-500 font-semibold mb-3">
                Media
              </p>

              {mediaItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.path}
                  onClick={() => setMobileOpen(false)}
                  className="block py-2 pl-4 text-slate-300 hover:text-red-500"
                >
                  {item.label}
                </Link>
              ))}
            </div> */}

            {/* <Link
  to="/contacts"
  onClick={() => setMobileOpen(false)}
  className="
  block
  text-center
  py-3
  bg-red-600
  text-white
  rounded-full
  font-semibold
  "
>
  Get A Quote
</Link> */}

          </div>
        </div>
      )}

    </header>
  );
}

export default Navbar;
